import React, { useEffect, useState } from "react";

const ContactHome = () => {
  const server_url = process.env.REACT_APP_SERVER_URL;
  const [msg, setMsg] = useState("");
  const [GenCaptcha, setGenCaptcha] = useState("");
  const [agree, setAgree] = useState(false);
  const [contactHomeData, setcontactHomeData] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  let name, value;
  const handleFormData = (e) => {
    name = e.target.name;
    value = e.target.value;

    setcontactHomeData({ ...contactHomeData, [name]: value });
    // console.log(contactHomeData);
  };

  const checkboxHandler = () => {
    console.log(agree);
    setAgree(!agree);
  };

  function generate() {
    let uniquechar = "";
    const randomchar =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 1; i <= 6; i++) {
      uniquechar += randomchar.charAt(Math.random() * randomchar.length);
    }
    // Store generated input
    setGenCaptcha(uniquechar);
  }
  useEffect(() => {
    generate();
  }, []);

  const sendContactHomeData = async (e) => {
    e.preventDefault();

    if (agree === true) {
      const formData = new FormData();
      formData.set("fullName", contactHomeData.fullName);
      formData.set("email", contactHomeData.email);
      formData.set("message", contactHomeData.message);
      formData.set("captcha", GenCaptcha);
      formData.set("captchaText", contactHomeData.captchaText);

      const res = await fetch(`${server_url}/contactHome`, {
        method: "post",
        body: formData,
      });
      const data = await res.json();
      if (data.status === 422 || data.error) {
        setMsg(data);
        setTimeout(() => {
          setMsg("");
        }, 5000);
        generate();
      } else {
        // console.log(data);
        setcontactHomeData({
          fullName: "",
          email: "",
          message: "",
          captchaText: ""
        });
        setMsg(data);
        setTimeout(() => {
          setMsg("");
        }, 5000);
        document.getElementById("agree").checked = false;
        generate();
      }
    } else {
      const data = { error: "Please Check Terms & Conditions" };
      setMsg(data);
      setTimeout(() => {
        setMsg("");
      }, 5000);
    }
  };

  return (
    <div>
      <div className="contact_section">
        <div className="container">
          <h2 className="contact_title text-center">Have a Project or Idea?</h2>
          <p className="contactsubtitle text-center pt-2">
            We will love to build something great together
          </p>
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="card contact_card">
                <div className="card-body">
                  <form method="POST" onSubmit={sendContactHomeData}>
                    <div className="row pt-3">
                      <div className="col-md-6">
                        <input
                          type="text"
                          name="fullName"
                          value={contactHomeData.fullName}
                          className="form-control contact_field mb-3"
                          autoComplete="new-password"
                          placeholder="Your Name"
                          onChange={handleFormData}
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          type="email"
                          name="email"
                          value={contactHomeData.email}
                          className="form-control contact_field mb-3"
                          autoComplete="new-password"
                          placeholder="Your Email"
                          onChange={handleFormData}
                        />
                      </div>

                      <div className="col-md-12">
                        <textarea
                          className="form-control contact_field"
                          rows="5"
                          name="message"
                          value={contactHomeData.message}
                          placeholder="Message"
                          onChange={handleFormData}
                        ></textarea>
                      </div>
                    </div>
                    <div className="row pt-3">
                      <div className="col-md-12">
                        <input
                          type="text"
                          className="form-control contact_field"
                          placeholder="Captcha Code"
                          name="captchaText"
                          value={contactHomeData.captchaText}
                          onChange={handleFormData}>

                        </input>
                      </div>
                    </div>
                    <div className="form-group pt-3">
                      <input
                        type="text"
                        className="captcha_code"
                        placeholder={GenCaptcha}
                        disabled
                      ></input>
                      <i className="fa fa-refresh" onClick={generate}></i>
                    </div>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        name="conditionCheck"
                        className="form-check-input"
                        id="agree"
                        onChange={checkboxHandler}
                      />
                      <label className="form-check-label">
                        By submitting the form, I agree to the privacy policy
                        and give my consent to receive emails/phone.
                      </label>
                    </div>
                    <div className="text-center pt-3">
                      <input
                        type="submit"
                        value="Submit"
                        className="btn btn_submit text-white"
                      />
                    </div>
                  </form>
                  {msg.message ? (
                    <div
                      className="text-success text-center pt-3"
                    >
                      {msg.message}
                    </div>
                  ) : (
                    ""
                  )}
                  {msg.error ? (
                    <div
                      className="text-danger text-center pt-3"
                    >
                      {msg.error}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContactHome;
